import { Controller, useFormContext } from 'react-hook-form'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EditorProps } from '@repo/shared-core-ui-tiptap/_mui-tiptap/types'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MuiTipTapEditor } from '@repo/shared-core-ui-tiptap/_mui-tiptap/MuiTiptapEditor'

// --------------------------------------------------------------------------------------------- //

type Props = EditorProps & {
  name: string
}

export function RHFEditorTipTap({ name, helperText, ...other }: Props) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error }, formState: { isSubmitSuccessful } }) => (
        <MuiTipTapEditor {...field} error={!!error} helperText={error?.message ?? helperText} resetValue={isSubmitSuccessful} {...other} />
      )}
    />
  )
}
